import type { IDBPDatabase } from "idb";
import CacheModule from "../cache-module";

export default class Lang extends CacheModule<string, string> {

    constructor(cache: IDBPDatabase) {
        super("lang", cache);
    }
}